<template>
  <section id="email-not-verified-banner">
    <Banner type="is-warning" icon="check" :show-close="true">
      <template #title>
        <span class="has-text-black has-text-weight-normal">
          {{ $t('core.please-to-your') }}
          <span class="has-text-primary" @click="whyRequiredLinkClicked">
            <TooltipView
              type="is-dark"
              :label="$t('core.we-make-to')"
              position="is-bottom"
              :multilined="true"
            >
              <span class="has-text-weight-semibold">{{ $t('core.why-is-required') }}</span>
            </TooltipView>
          </span>
        </span>
      </template>
      <template #action-button>
        <ButtonView
          type="is-primary"
          :loading="isSendingMail"
          outlined
          @click="resendVerificationMail"
          class="p-t-0 p-b-0"
          :data-e2e="AuthCypressAttribute.buttons.RESEND_INVITE"
        >
          {{ $t('core.resend-link') }}
        </ButtonView>
      </template>
    </Banner>
  </section>
</template>

<script>
import Banner from '/@/modules/core/ui/components/Banner.vue';
import { ResendEmailVerificationMixin } from '/@/modules/core/app/mixins/ResendEmailVerificationMixin';
import { AuthCypressAttribute } from '@/modules/auth/constants/AuthCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EmailNotVerifiedBanner',
  mixins: [ResendEmailVerificationMixin],
  components: { TooltipView, ButtonView, Banner },
  static: {
    AuthCypressAttribute
  },
  methods: {
    whyRequiredLinkClicked() {
      //
    }
  }
};
</script>

<style scoped>
#email-not-verified-banner {
  margin: var(--ce-20px) var(--ce-40px);
}
</style>
